import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import EditSellyoMembers from "../../../components/apps/sellyo-members/EditSellyoMembers";
import { useNavigate } from "react-router";

export default function EditSellyoMembersPage() {
    const navigate = useNavigate();
    return (
        <>
            <PageMeta title="Sellyo Members — Editar Integração" description="Editar integração Sellyo Members" />
            <PageBreadcrumb
                pageTitle="Editar Integração"
                showBackButton={true}
                onBack={() => navigate("/apps/sellyo-members")}
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">
                <div className="col-span-12 space-y-6">
                    <EditSellyoMembers />
                </div>
            </div>
        </>
    );
}